<template>
    <section class="employee-registry-contacts">
        <template v-if="contacts.length || telegramLinks.length">
            <span v-for="(contact, index) in visibleContacts" :key="index"
                  class="employee-registry-contacts__line"
                  :class="{'employee-registry-contacts__line--phone': contact.isPhone}"
                  :title="contact.text">
                <EmployeePhoneMenu v-if="contact.isPhone" :value="contact.value" :telegram-username="telegramUsername" />
                <template v-else>{{ contact.text }}</template>
            </span>
            <span class="employee-registry-contacts__actions">
                <a v-for="link in telegramLinks" :key="link.url" :href="link.url"
                   target="_blank" rel="noopener noreferrer" :title="link.label"
                   @click.stop>
                    <i class="fab fa-telegram-plane" aria-hidden="true"></i>
                    {{ telegramLinks.length > 1 ? `Telegram: ${link.label}` : 'Открыть Telegram' }}
                </a>
                <button v-if="contacts.length > previewLimit" type="button"
                        class="employee-registry-contacts__toggle"
                        :aria-expanded="expanded ? 'true' : 'false'"
                        @click.stop="expanded = !expanded">
                    {{ expanded ? 'Свернуть' : `Ещё… (${contacts.length - previewLimit})` }}
                </button>
            </span>
        </template>
        <span v-else class="text-muted">—</span>
    </section>
</template>

<script>
import {formatPhone} from '@/utils/phone';
import {employeeTelegramLinks, employeeTelegramUsername} from '@/utils/employeeTelegram';
import EmployeePhoneMenu from '@/components/EmployeePhoneMenu.vue';

export default {
    name: 'EmployeeRegistryContacts',
    components: {EmployeePhoneMenu},
    props: {
        employee: {type: Object, required: true}
    },
    data() {
        return {expanded: false, previewLimit: 2};
    },
    computed: {
        telegramUsername() { return employeeTelegramUsername(this.employee) || ''; },
        telegramLinks() { return employeeTelegramLinks(this.employee); },
        contacts() {
            const contacts = (this.employee.contact_methods || []).filter(contact => (
                String(contact.contact_type || contact.type || '').toLowerCase() !== 'telegram'
            )).map(contact => {
                const isPhone = String(contact.contact_type || contact.type || '').toLowerCase() === 'phone';
                return {isPhone, value: contact.value, text: isPhone ? formatPhone(contact.value, contact.value) : contact.value};
            }).filter(contact => contact.text);
            return contacts;
        },
        visibleContacts() {
            return this.expanded ? this.contacts : this.contacts.slice(0, this.previewLimit);
        }
    }
};
</script>

<style scoped>
.employee-registry-contacts {
    min-width: 0;
}
.employee-registry-contacts__line {
    display: block;
    line-height: 1.5;
    white-space: nowrap;
}
.employee-registry-contacts__line:not(.employee-registry-contacts__line--phone) {
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
}
.employee-registry-contacts__line--phone {
    font-variant-numeric: tabular-nums;
}
.employee-registry-contacts__toggle {
    display: block;
    padding: 2px 0;
    border: 0;
    background: transparent;
    color: #1668c7;
    font: inherit;
    cursor: pointer;
}
.employee-registry-contacts__actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 12px;
}
.employee-registry-contacts__toggle:hover {
    text-decoration: underline;
}
@media (max-width: 767px) {
    .employee-registry-contacts__line:not(.employee-registry-contacts__line--phone) {
        max-width: 100%;
    }
}
</style>
